export function hasTimeSlotShippingMethods(checkout) {
  var _checkout$shippingInf;
  return ((_checkout$shippingInf = checkout.shippingInfo) == null || (_checkout$shippingInf = _checkout$shippingInf.carrierServiceOptions) == null ? void 0 : _checkout$shippingInf.some(_ref => {
    let {
      shippingOptions
    } = _ref;
    return (shippingOptions == null ? void 0 : shippingOptions.some(_ref2 => {
      var _logistics$deliveryTi;
      let {
        logistics
      } = _ref2;
      return !!(logistics != null && (_logistics$deliveryTi = logistics.deliveryTimeSlot) != null && _logistics$deliveryTi.from);
    })) ?? false;
  })) ?? false;
}
//# sourceMappingURL=hasTimeSlotShippingMethods.js.map